import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

interface ValidationConfigTabProps {
  config: Record<string, unknown>;
  setConfig: (config: Record<string, unknown>) => void;
}

export const ValidationConfigTab: React.FC<ValidationConfigTabProps> = ({
  config,
  setConfig,
}) => {
  const updateConfig = (key: string, value: unknown) => {
    setConfig({ ...config, [key]: value });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-2 p-3 bg-muted/50 rounded-lg">
        <Info className="h-5 w-5 text-primary mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">
          This section is optional and can be configured later.
        </p>
      </div>

      <Card className="border-dashed">
        <CardContent className="pt-4 space-y-4">
          <div className="space-y-2">
            <Label className="text-sm">Amount Validation:</Label>
            <Select
              value={(config.validation_method as string) || 'historical'}
              onValueChange={(value) => updateConfig('validation_method', value)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select validation method" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="historical">Historical Average</SelectItem>
                <SelectItem value="fixed">Fixed Threshold</SelectItem>
                <SelectItem value="none">No Validation</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Alert if variance &gt;</Label>
            <div className="flex items-center gap-2">
              <Input
                type="number"
                min="0"
                max="100"
                value={(config.variance_threshold as number) || 20}
                onChange={(e) => updateConfig('variance_threshold', parseInt(e.target.value) || 20)}
                className="w-24"
              />
              <span className="text-sm text-muted-foreground">%</span>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox
              id="require_approval"
              checked={(config.require_approval as boolean) || false}
              onCheckedChange={(checked) => updateConfig('require_approval', !!checked)}
            />
            <Label htmlFor="require_approval" className="text-sm font-normal">
              Require approval for high variance
            </Label>
          </div>
        </CardContent>
      </Card>

    </div>
  );
};
